import React from 'react';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Privacy from './components/Privacy';
import Contact from './components/Contact';

import { HashRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <div className="app-content">
          <Switch>
            <Route exact path="/"> <Redirect to="/home" /> </Route>
            <Route path="/home"> <Home /> </Route>
            <Route path="/privacy"> <Privacy /> </Route>
            <Route path="/contact"> <Contact /> </Route>
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
